var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Input, Typography } from "@material-ui/core";
import "../styles/AuthStylesheet.css";
import { isValidEmailAddress, requestPasswordReset } from "./auth_util";
import { FormattedMessage, injectIntl } from "react-intl";
var ForgotPasswordDialog = /** @class */ (function (_super) {
    __extends(ForgotPasswordDialog, _super);
    function ForgotPasswordDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEmailChange = function (email) {
            _this.setState({
                emailAddress: email,
                submitEnabled: email.length > 0
            });
        };
        _this.onCancelClicked = function () {
            _this.props.onClose();
        };
        _this.onSubmitClicked = function () {
            var errorMessage = _this.validateInputs();
            if (errorMessage) {
                _this.setState({ errorMessage: errorMessage });
                return;
            }
            _this.setState({
                errorMessage: "",
                loading: true,
                submitEnabled: false
            });
            var email = _this.state.emailAddress;
            requestPasswordReset(email).then(_this.onResetRequestCompleted).catch(function (err) { return console.error(err); });
        };
        _this.onCloseClicked = function () {
            _this.props.onClose();
        };
        _this.onResetRequestCompleted = function () {
            _this.setState({ resetRequestCompleted: true });
        };
        _this.state = {
            emailAddress: "",
            submitEnabled: false,
            errorMessage: "",
            loading: false,
            resetRequestCompleted: false
        };
        _this.intl = props.intl;
        return _this;
    }
    ForgotPasswordDialog.prototype.componentDidMount = function () {
        this.setState({ resetRequestCompleted: false });
    };
    ForgotPasswordDialog.prototype.render = function () {
        return (React.createElement(Dialog, { open: true, onClose: this.props.onClose },
            React.createElement(DialogTitle, null,
                React.createElement(FormattedMessage, { id: "authentication-password_reset-header" })),
            React.createElement(DialogContent, null, this.renderDialogContent()),
            React.createElement(DialogActions, null, this.renderDialogActions())));
    };
    ForgotPasswordDialog.prototype.renderDialogContent = function () {
        var _this = this;
        if (this.state.resetRequestCompleted)
            return ForgotPasswordDialog.renderResetCompletedMessage();
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, null,
                React.createElement(FormattedMessage, { id: "authentication-password_reset-description" })),
            React.createElement("div", null,
                React.createElement("label", { className: "label" },
                    this.intl.formatMessage({ id: "authentication-password_reset-email_input-label" }),
                    " *"),
                React.createElement(Box, { width: 300 },
                    React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handleEmailChange(evt.target.value); }, type: "text", placeholder: this.intl.formatMessage({ id: "authentication-password_reset-email_input-placeholder" }), required: true }))),
            this.renderErrorMessage()));
    };
    ForgotPasswordDialog.renderResetCompletedMessage = function () {
        return (React.createElement(Typography, null,
            React.createElement(FormattedMessage, { id: "authentication-password_reset-completion_msg" })));
    };
    ForgotPasswordDialog.prototype.renderDialogActions = function () {
        if (this.state.resetRequestCompleted)
            return this.renderResetCompletedButton();
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "contained", color: "secondary", onClick: this.onCancelClicked },
                React.createElement(FormattedMessage, { id: "authentication-password_reset-cancel" })),
            React.createElement(Button, { variant: "contained", color: "primary", disabled: !this.state.submitEnabled, onClick: this.onSubmitClicked },
                React.createElement("span", null,
                    this.renderLoading(),
                    React.createElement(FormattedMessage, { id: "authentication-password_reset-confirm" })))));
    };
    ForgotPasswordDialog.prototype.renderResetCompletedButton = function () {
        return (React.createElement(Button, { variant: "contained", color: "primary", onClick: this.onCloseClicked },
            React.createElement(FormattedMessage, { id: "authentication-password_reset-close" })));
    };
    ForgotPasswordDialog.prototype.renderErrorMessage = function () {
        if (this.state.errorMessage === "")
            return null;
        return (React.createElement(Typography, { className: "error" }, this.state.errorMessage));
    };
    ForgotPasswordDialog.prototype.renderLoading = function () {
        if (!this.state.loading)
            return null;
        return (React.createElement(CircularProgress, { className: "progress", color: "inherit", size: 20 }));
    };
    ForgotPasswordDialog.prototype.validateInputs = function () {
        if (!isValidEmailAddress(this.state.emailAddress))
            return this.intl.formatMessage({ id: "authentication-password_reset-email_invalid" });
        return undefined;
    };
    return ForgotPasswordDialog;
}(React.PureComponent));
export { ForgotPasswordDialog };
export default injectIntl(ForgotPasswordDialog);
//# sourceMappingURL=ForgotPasswordDialog.js.map